module.exports = __webpack_public_path__ + "img/118D&118DW.3198647d.svg";